import { render, staticRenderFns } from "./datagl.vue?vue&type=template&id=bd98aa46&"
import script from "./datagl.vue?vue&type=script&lang=js&"
export * from "./datagl.vue?vue&type=script&lang=js&"
import style0 from "./datagl.vue?vue&type=style&index=0&id=bd98aa46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports